import React from 'react';
import Portfolio from '../Portfolio';
import Div from '../Div';
import Slider from 'react-slick';

export default function ProjectSlider({ data }) {
  /** Slider Settings **/
  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    slidesToShow: 3,
    speed: 500,
    dots: true,
    arrows: false,
    autoplay: true,     
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Replicate data if less than 4 items
  let replicatedData = [...data];
  if (replicatedData.length > 0 && replicatedData.length < 4) {
    let i = 0;
    while (replicatedData.length < 4) {
      replicatedData.push({ ...replicatedData[i], id: `replica-${i}-${Date.now()}` });
      i = (i + 1) % data.length;
    }
  }

  return (
    <Slider {...settings} className="cs-slider cs-style3 cs-gap-24">
      {replicatedData.map((item, index) => (
        <Div key={index}>
          <Portfolio
            title={item.title}
            subtitle={item.subtitle}
            href={item.href}
            src={item.src}
          />
        </Div>
      ))}
    </Slider>
  );
}
